
import { ButtonHTMLAttributes, ReactNode } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  children: ReactNode;
}

export default function Button({ 
  variant = 'primary', 
  size = 'md', 
  children, 
  className = '', 
  ...props 
}: ButtonProps) {
  const baseClasses = 'whitespace-nowrap cursor-pointer font-medium transition-all duration-300 flex items-center justify-center gap-2 border transform hover:scale-[1.02] active:scale-[0.98]';
  
  const variantClasses = {
    primary: 'bg-[#6607a5] hover:bg-[#5a0690] text-white border-[#6607a5] hover:border-[#5a0690] shadow-lg hover:shadow-xl',
    secondary: 'bg-gray-50 hover:bg-gray-100 text-[#6607a5] border-gray-200 hover:border-gray-300 shadow-sm hover:shadow-md',
    outline: 'border-[#6607a5] hover:border-[#5a0690] text-[#6607a5] hover:bg-[#6607a5] hover:text-white bg-transparent backdrop-blur-sm',
    ghost: 'text-[#6607a5] hover:bg-purple-50 border-transparent hover:border-purple-100'
  };
  
  const sizeClasses = {
    sm: 'px-4 py-2 text-sm rounded-full',
    md: 'px-6 py-3 text-sm rounded-full',
    lg: 'px-8 py-3.5 text-sm rounded-full'
  };
  
  return (
    <button 
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
